import React from 'react';
import { StyleSheet } from 'react-native';

import { LineSeparator } from '@/components/LineSeparator';
import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';
import { isWeb } from '@/utils/constants-platform-specific';

import { RACE_TO_PLACE_LOBBY_HEIGHT } from '../race-to-place/race-to-place-constants';

export const RaceToPlaceSkeleton = () => {
    return (
        <Box
            height={RACE_TO_PLACE_LOBBY_HEIGHT}
            borderRadius={'r20'}
            px={'s16'}
            backgroundColor={ds.colorToken.background.neutral.subtler}
            pt={'s32'}
        >
            <Row gap={'s24'} overflow={'hidden'}>
                <Row gap={'s12'}>
                    {Array.from({ length: isWeb ? 5 : 2 }).map((_, index) => {
                        return (
                            <Row key={`skeleton-${index}`}>
                                <LoadingSkeleton
                                    borderRadius={'r10'}
                                    skeletonColor={designSystem.colors.neutral300}
                                    backgroundColor={ds.colorToken.background.neutral.strong}
                                    width={40}
                                    height={40}
                                />
                                <Box>
                                    <LoadingSkeleton
                                        borderRadius={'r4'}
                                        skeletonColor={designSystem.colors.neutral300}
                                        width={87}
                                        height={20}
                                    />
                                    <LoadingSkeleton
                                        borderRadius={'r4'}
                                        skeletonColor={designSystem.colors.neutral300}
                                        width={168}
                                        height={20}
                                    />
                                </Box>
                            </Row>
                        );
                    })}
                </Row>
            </Row>

            <LineSeparator style={styles.separator} />

            <Box overflow={'hidden'} mb={'s16'}>
                <LoadingSkeleton
                    borderRadius={'r2'}
                    backgroundColor={ds.colorToken.background.neutral.strong}
                    skeletonColor={designSystem.colors.neutral300}
                    height={4}
                />
            </Box>

            <Box>
                <LoadingSkeleton
                    borderRadius={'r12'}
                    backgroundColor={ds.colorToken.background.neutral.strong}
                    skeletonColor={designSystem.colors.neutral300}
                    height={44}
                    style={styles.button}
                />
            </Box>
        </Box>
    );
};

const styles = StyleSheet.create({
    logo: {
        borderRadius: 13,
    },
    separator: { marginVertical: 24 },
    button: {
        width: '100%',
    },
});
